import { classNames } from "@offstreetparking/design-system/utils";
import React from "react";
import { useElementPresent } from "../../../hooks/useElementPresent";
import { ELEMENT_ID as BOTTOM_BAR_ELEMENT_ID } from "../BottomBar";

export const ELEMENT_ID = "button-row";

export const ButtonRow = ({
	children,
	className,
	isInline = false,
}: {
	children: React.ReactNode;
	className?: string;
	isInline?: boolean;
}) => {
	const { isElementVisible: isBottomBarVisible } = useElementPresent({ id: BOTTOM_BAR_ELEMENT_ID });

	return (
		<div
			id={ELEMENT_ID}
			className={
				isInline
					? undefined
					: classNames(
							"fixed right-0 left-0 z-footer mb-0 border-t bg-neutral-faded md:relative md:bottom-auto md:border-0 md:bg-white",
							isBottomBarVisible ? "bottom-20" : "bottom-0",
						)
			}
		>
			<div
				className={classNames(
					`flex ${React.Children.count(children) === 1 ? "justify-end" : "justify-between"}`,
					isInline ? "" : "mx-4 my-4 md:mx-0 md:my-0",
					className,
				)}
			>
				{children}
			</div>
		</div>
	);
};
